import React from 'react'
import FlexLayout from 'src/components/FlexLayout'
import Text from 'src/components/Text'
import { handleOnKeyDownButton } from 'src/utils/Form'
import * as S from './BarcodeProductInput.style'

interface BarcodeProductInputProps {
  value?: string;
  errorMessage: JSX.Element;
  setFieldValue: (field: string, value: string) => void;
  validateField: (field: string) => void;
}

const BarcodeProductInput = ({
  value,
  errorMessage,
  setFieldValue,
  validateField,
}: BarcodeProductInputProps) => (
  <FlexLayout style={{ margin: '10px 0 0 0' }} justify='center'>
    <FlexLayout direction='column'>
      <Text textType='defaut' text='fraction.form.code' />
      <S.Field
        id='barcodeProduct'
        name='barcodeProduct'
        value={value}
        onChange={(e) => {
          setFieldValue('barcodeProduct', e.target.value)
        }}
        type='text'
        placeholder='Bipar'
        data-testid='input-barcodeProduct'
        onBlur={() => validateField('barcodeProduct')}
        onKeyDown={(e) =>
          handleOnKeyDownButton<HTMLInputElement>(e, 'finishButton', () => {
            document.getElementById('finishButton')?.click()
          })}
      />
      {errorMessage}
    </FlexLayout>
  </FlexLayout>
)

export default React.memo(BarcodeProductInput)
